module.exports = __webpack_public_path__ + "img/initialresults.e396fdc7.png";